import styled from 'styled-components'

export const BottomContentContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`
